(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var i18nQuantity = drawer.dataset.i18nQuantity || 'Menge';
  var i18nRemove = drawer.dataset.i18nRemove || 'Entfernen';

  var body = drawer.querySelector('[data-cart-drawer-body]');
  var emptyMsg = document.querySelector('[data-cart-drawer-empty]');
  var footer = document.querySelector('[data-cart-drawer-footer]');
  var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-drawer-count]');

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function render(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count === 0) el.setAttribute('data-zero', ''); else el.removeAttribute('data-zero');
    });

    if (!cart.item_count) {
      body.innerHTML = '';
      if (emptyMsg) emptyMsg.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }

    if (emptyMsg) emptyMsg.hidden = true;
    if (footer) footer.hidden = false;
    if (subtotalEl) subtotalEl.textContent = Theme.formatMoney(cart.total_price);

    body.innerHTML = cart.items.map(function (item, idx) {
      var line = idx + 1;
      return (
        '<div class="cart-drawer__item">' +
          (item.image ? '<img src="' + item.image + '&width=160" alt="" width="64" height="64" loading="lazy">' : '<span></span>') +
          '<div>' +
            '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-drawer__item-controls">' +
              '<input type="number" min="0" value="' + item.quantity + '" data-cart-drawer-qty data-line="' + line + '" aria-label="' + escapeHtml(i18nQuantity) + '">' +
              '<button type="button" data-cart-drawer-remove data-line="' + line + '">' + escapeHtml(i18nRemove) + '</button>' +
            '</div>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + Theme.formatMoney(item.final_line_price) + '</p>' +
        '</div>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  body.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-drawer-qty]')) {
      var line = e.target.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: e.target.value })
      }).then(function (r) { return r.json(); }).then(render);
    }
  });
  body.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-remove]')) {
      var line = e.target.closest('[data-cart-drawer-remove]').getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(render);
    }
  });

  document.addEventListener('cart:updated', open);

  // No unconditional fetchCart() here: the bubble count is already correct
  // from the server-rendered cart item count on load (this snippet renders
  // sitewide), and open() above fetches fresh cart state the moment the
  // drawer is actually opened — fetching on every single pageview regardless
  // of purchase intent would be pure waste.
})();
  } catch(e) { console.error(e); }
})();

})();
